import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 2fr;
  grid-gap: 3rem;
  row-gap: 1em;
  align-items: center;
`;

export const RolesInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 3.3fr;
  grid-gap: 3rem;
  row-gap: 1em;
  align-items: center;

  .role-info-box {
    padding: 24px;
    background: ${colorTokens.background.light};
  }

  [data-testid='assigned-locations'] {
    grid-column: 2 / 4;
  }
`;
